import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { logisticsApi, type LogisticsDashboard } from '../../api/logistics';

export function LogisticsAnalyticsPage() {
  const [dash, setDash] = useState<LogisticsDashboard | null>(null);

  useEffect(() => {
    void logisticsApi.dashboard().then(setDash);
  }, []);

  return (
    <div className="mx-auto max-w-6xl p-6">
      <Link to="/logistics" className="text-sm text-slate-600 hover:underline">← Logistics hub</Link>
      <h1 className="mt-2 text-2xl font-semibold">Shipping analytics</h1>
      {dash && (
        <div className="mt-6 grid gap-4 sm:grid-cols-2">
          <div className="rounded-xl border p-4">
            <p className="text-sm text-slate-500">Delivery success proxy</p>
            <p className="text-2xl font-semibold">{(dash.on_time_rate * 100).toFixed(1)}%</p>
          </div>
          <div className="rounded-xl border p-4">
            <p className="text-sm text-slate-500">Active carriers</p>
            <p className="text-2xl font-semibold">{dash.active_carriers}</p>
          </div>
          <div className="rounded-xl border p-4">
            <p className="text-sm text-slate-500">Exceptions (failed)</p>
            <p className="text-2xl font-semibold">{dash.failed}</p>
          </div>
          <div className="rounded-xl border p-4">
            <p className="text-sm text-slate-500">In transit</p>
            <p className="text-2xl font-semibold">{dash.in_transit}</p>
          </div>
        </div>
      )}
    </div>
  );
}
